import { ReactElement } from "react";
import { Box, CircularProgress, Typography } from "@mui/material";
import ReportingDataviz from "../ReportingDataViz";
import { PageContainer } from "../../components/Common";
import { useGetDynamicReportingMenu } from "../../hooks/PowerBI";
import { useLanguage } from "../../context/LanguageContext";

const Dashboard = (): ReactElement => {
  const { t } = useLanguage();
  // Le rapport d'accueil suit les droits PowerBI de la section DataViz (l'API le refuse sinon)
  const { canSeeReportingSection, accessChecked, loading, error } = useGetDynamicReportingMenu();

  // Le message « DataViz non ouvert » n'apparaît qu'une fois les droits ET la configuration PowerBI chargés
  if (!error && (loading || !accessChecked)) {
    return (
      <PageContainer isDatavizPage={true}>
        <Box sx={{ display: "flex", justifyContent: "center", py: 8 }}><CircularProgress /></Box>
      </PageContainer>
    );
  }

  return (
    <PageContainer isDatavizPage={true}>
      {canSeeReportingSection && !error ? (
        <ReportingDataviz labelReport="Home" />
      ) : (
        <Box sx={{ textAlign: "center", py: 8 }}>
          <Typography variant="h6">{t("common.rights.welcomeTitle")}</Typography>
          {/* Configuration PowerBI indisponible : accès inconnu, on n'affirme pas que DataViz est fermé */}
          {!error && <Typography variant="body2" color="text.secondary">{t("common.rights.noReporting")}</Typography>}
        </Box>
      )}
    </PageContainer>
  );
};

export default Dashboard;
